export const kratos_registration_flow = {
  link_login: "Log In",
  registration_failed: "Registration failed.",
  post_reg_login_failed:
    "Your account was created, but signing you in failed. Try logging in from the login page.",
  already_registered: "Already have an account?",
};
